import { authenticatedBitswanBackendInstance } from "@/lib/api-client";

export type ChangePasswordInput = {
  current_password: string;
  new_password: string;
};

export async function changePassword(input: ChangePasswordInput) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.post("/users/me/password", input);
  return res.data as { success: boolean };
}

export async function updateAvatar(avatar: string | null) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.post("/users/me/avatar", { avatar });
  return res.data as { avatar: string | null };
}

export type ProfileInput = {
  first_name: string;
  last_name: string;
};

export async function updateProfile(input: ProfileInput) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.post("/users/me/profile", input);
  return res.data as ProfileInput;
}
